import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import Utils from '@shared/utils/utils';
import Configs from '@shared/constants/configs';
import Roles from '@shared/constants/roles';
import { ApiService } from '@shared/apis';
import { FileService } from '@shared/services/file.service';

@Component({
  selector: 'app-dp-file-select',
  templateUrl: './dp-file-select.component.html',
  styleUrls: ['./dp-file-select.component.scss']
})
export class DpFileSelectComponent implements OnInit {
  readonly configs = Configs;
  readonly roles = Roles;
  @Output()
  outFile = new EventEmitter();
  @Output()
  fileDelete = new EventEmitter();
  files: any[] = [];
  file: any;
  @ViewChild('imgFileInput') imgFileInput: ElementRef;

  constructor(private apiService: ApiService,
              private fileService: FileService) {
  }

  _initInfo: any;

  @Input()
  set initInfo(value) {
    if (!value) {
      return
    }
    this._initInfo = value;
  };

  _fileInfo: any;

  @Input()
  set fileInfo(value) {
    this._fileInfo = value;
    this.file = value;
  };

  _deletable: boolean;

  @Input()
  set deletable(value) {
    if (!value) {
      return;
    }
    this._deletable = value;
  }

  ngOnInit(): void {
  }

  fileSelected(event): any {
    const files = event.target.files;

    this.files = files;

    if (this.files.length > 0) {
      const overLimit = Array.from(this.files).some((f: any) => {
        return (f.size > this.configs.fileLimit.limit);
      });

      if (overLimit) {
        this.imgFileInput.nativeElement.value = '';
        const size = (this.configs.fileLimit.limit / (1024 * 1024)).toFixed(0);
        Utils.showError({ message: `The file is too large.  Please select size ${ size }MB or less.` });
        return false;
      }

    }
    // this.file = files[0];
    // this.outFile.emit(this.file);

    this.outFile.emit(this.files);
  }

  delete() {
    this.fileDelete.emit(this.file);
    this.file = null;
    this.files = [];
  }

  clickFile() {
    const url = this.apiService.concealedDamage.fileUrl(this._fileInfo?.file, 'attachment');
    const { filename } = this._fileInfo?.file;
    this.fileService.downloadFile(url, filename);
  }

}
